import { createContext, useContext } from 'react';

const ArtifactExportContext = createContext(false);

const ArtifactExportProvider = ArtifactExportContext.Provider;

/**
 * Returns `true` while the artifact is being rendered for export — a PDF, or a
 * headless-Chrome screenshot bound for Slack/Teams. Artifacts use this to drop
 * animations and to lift scroll caps, since an element screenshot clips
 * overflow instead of scrolling it.
 * @returns {boolean} Whether the artifact is being rendered for export.
 */
function useIsExporting(): boolean {
  return useContext(ArtifactExportContext);
}

export { ArtifactExportProvider, useIsExporting };
